/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsqueryRecommendationsNeighborsItemIdGet$Params {
  itemId: string;
}

export function apiProductsqueryRecommendationsNeighborsItemIdGet(http: HttpClient, rootUrl: string, params: ApiProductsqueryRecommendationsNeighborsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryRecommendationsNeighborsItemIdGet.PATH, 'get');
  if (params) {
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsqueryRecommendationsNeighborsItemIdGet.PATH = '/api/productsquery/recommendations/neighbors/{itemId}';
